import * as Yup from "yup";

export const campaignSchema = Yup.object().shape({
  title: Yup.string().required("O título é obrigatório"),
  message: Yup.string().required("A mensagem é obrigatória"),
  conclusion_message: Yup.string().required(
    "A mensagem de conclusão é obrigatória",
  ),
  processing_status: Yup.mixed<
    "pending" | "processing" | "completed" | "failed"
  >()
    .oneOf(["pending", "processing", "completed", "failed"])
    .required("O status de processamento é obrigatório"),
});
